// EventList.js

export default function EventList({ events }) {
  if (!events.length) return null;

  const formatDateTime = (event) => {
    const raw = event.date_obj || event.date_time;
    const dt = raw ? new Date(raw) : null;
    if (!dt || Number.isNaN(dt.getTime())) {
      return { date: event.date_time || "TBA", time: "TBA" };
    }
    return {
      date: dt.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" }),
      time: dt.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }),
    };
  };

  return (
    <ul className="event-list">
      {events.map((event, idx) => {
        const { date, time } = formatDateTime(event);
        const venue = event.venue || "Venue TBA";
        const city = event.city || "City TBA";
        return (
          <li key={idx} className="event-item">
            <h3 className="event-title">{event.name}</h3>
            <div className="event-meta">
              {venue} - {city}
            </div>
            <div className="event-row">
              <span className="event-tag">{date}</span>
              <span className="event-tag">{time}</span>
              {event.price && <span className="event-tag">Price: {event.price}</span>}
            </div>
            {event.ticket_url && (
              <span className="ticket-wrap">
                <a
                  className="event-link"
                  href={event.ticket_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View tickets
                </a>
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
